import axios from 'axios';
import { LOG_IN, LOG_OUT, REFRESH_ACCESS_TOKEN } from './mutation-types';

export function logIn({ commit }, creds) {
    return new Promise((resolve, reject) => {
        axios.post(`${process.env.API}/api/operation/login`, creds).then((response) => {
            commit(LOG_IN, response.data);
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export function googleLogIn({ commit }, code) {
    return new Promise((resolve, reject) => {
        axios.get(`${process.env.API}/api/operation/google-login?code=${code}`).then((response) => {
            commit(LOG_IN, response.data);
            resolve();
        }).catch((error) => {
            reject(error);
        });
    });
}

export function logOut({ commit }) {
    commit(LOG_OUT);
}

export function refreshToken({ commit }, payload) {
    return new Promise((resolve, reject) => {
        axios.post(`${process.env.API}/api/operation/refreshtoken`, payload).then((response) => {
            commit(REFRESH_ACCESS_TOKEN, response.data);
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js